const INITIAL_STATE = {
    data: null
}

const DadosPessoalReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'dadospessoal': {

            return {
                ...state,
                data: action.payload.dadospessoal
            }
        }
        default: {
            return state
        }
    }
}

export default DadosPessoalReducer